module.exports = __webpack_public_path__ + "static/media/fvs_hamburgerKunsthalle_7.40375ce3.jpg";